import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  ThaiCardDetails: [],
  isLoading: false,
  error: "",
  hasData: false
};
const thaiCardSlice = createSlice({
  name: "thaicard",
  initialState,
  reducers: {
    thaiCardDataRequest: state => {
      state.isLoading = true;
    },
    getThaiCardDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.ThaiCardDetails = action.payload;
    },
    getThaiCardDataFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});
export const {
  thaiCardDataRequest,
  getThaiCardDataFailure,
  getThaiCardDataSuccess
} = thaiCardSlice.actions;
export default thaiCardSlice.reducer;